<div role="tablist" class="aa-wizard">
  <div class="aa-all-steps">
    @for (step of steps; track step; let idx = $index; let isLast = $last) {
      <div class="aa-step" [class.active]="step.active" [class.disabled]="step.disabled" [class.deactivated]="step.deactivated">
        <div
          [style.height.px]="height"
          class="aa-step-title"
          (click)="onClickStep(idx)"
          >
          @if (!isLast) {
            <div class="step">
              <div class="step-text">
                {{ 'WIZARD.STEPS.NAME' | translate }}&nbsp;{{ idx + 1 }}
              </div>
              @if (!step.active && step.valid) {
                <aa-icon-circle class="success duotone" [faIcon]="'fal fa-check'"></aa-icon-circle>
              }
              @if (step.active && step.valid !== null && !step.valid) {
                <aa-icon-circle class="danger duotone" [faIcon]="'fal fa-times'"></aa-icon-circle>
              }
            </div>
          }
          @if (isLast) {
            <div class="step">
              &nbsp;
            </div>
          }
          <div class="title">
            {{ step.title }}
            <ng-template
              [ngTemplateOutlet]="$safeNavigationMigration(step.titleTpl?.templateRef)"
            ></ng-template>
          </div>
        </div>
        <div class="aa-step-border"></div>
      </div>
    }
  </div>
  <div class="aa-next-step">
    <div class="aa-step" >
      <div [style.height.px]="height" class="aa-step-title" (click)="onClickNextStep()">
        <div class="step">&nbsp;</div>
        <div class="title">
          {{'WIZARD.BUTTONS.NEXT' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="aa-step-content">
  @for (step of steps; track step) {
    @if (step.active) {
      <div
        role="tabpanel"
        [attr.aria-labelledby]="step.id"
        id="{{ step.id }}-panel"
        >
        <ng-template
          [ngTemplateOutlet]="$safeNavigationMigration(step.contentTpl?.templateRef)"
        ></ng-template>
      </div>
    }
  }
</div>
